import React from "react";

import { Routes, Route } from "react-router-dom";

import MainLayout from "../layout/MainLayout";

import Home from "../pages/Home/Home";
import About from "../pages/About/About";
import Services from "../pages/Services/Services";
import Pricing from "../pages/Pricing/Pricing";
import Contact from "../pages/Contact/Contact";
import NotFound from "../components/Common/NotFound";
import PrivacyPolicy from './../pages/PrivacyPolicy';
import TermsConditions from './../pages/TermsConditions';
import ScrollToTop from "../components/Common/ScrollToTop";

function AppRoutes() {
  return (
    <Routes>
      {/* MAIN LAYOUT */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />

        <Route path="/about" element={<About />} />

        <Route path="/services" element={<Services />} />

        <Route path="/pricing" element={<Pricing />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />

        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
